<template>
  <article class="article-card">
    <div class="content">
      <p class="t-h5 title" v-html="item.title" />
      <div
        class="description t-p-m-160"
        v-html="nbsp(extractFirstParagraph(item.description))"
      />
      <BaseButton
        tag="a"
        :href="item.absolute_url"
        color="secondary"
        :text="t('read-more')"
        class="button"
      />
    </div>
    <BaseImage :image="item.image" class="image" />
  </article>
</template>

<script lang="ts" setup>
import type { SimplePublicArticle } from '@/service/__generated-api'

const { t } = useI18n()

defineProps<{ item: SimplePublicArticle }>()
</script>

<style lang="scss" scoped>
.article-card {
  @include flex-col;
  column-gap: rem(80px);
  padding: rem(14px);
  background-color: $layout-background-02;
  border-radius: $border-radius;
  box-shadow: $base-shadow;

  @include media-up(s-lg) {
    flex-direction: row;
  }

  :deep(.image-wrapper) {
    height: rem(214px);

    @include media-up(md) {
      height: rem(448px);
    }

    @include media-up(s-lg) {
      width: rem(378px);
      height: rem(252px);
    }
  }
}

.content {
  @include flex-col;
  justify-content: space-between;
  order: 2;
  padding-block: rem(40px) rem(26px);
  padding-inline: rem(6px);
  @include media-up(md) {
    padding-inline: rem(34px);
  }
  @include media-up(s-lg) {
    padding: rem(26px) rem(66px) rem(26px) 0;
  }
}

.title {
  margin-bottom: rem(12px);
}

.description {
  @include line-clamp(4);
  margin-bottom: rem(18px);
  word-break: break-word;

  @include media-up(md) {
    @include line-clamp(2);
  }

  @include media-up(s-lg) {
    @include line-clamp(4);
  }
}

.image {
  flex-shrink: 0;
  order: 1;
  width: 100%;
  height: rem(214px);
  overflow: hidden;
  border-radius: $border-radius-small;

  @include media-up(md) {
    height: rem(448px);
  }

  @include media-up(s-lg) {
    width: rem(378px);
    height: rem(252px);
  }
}

.button {
  margin-top: auto;
  margin-right: auto;
}
</style>
